
export const globalInstance = (globalKey: string, classDef: any) => {
  if (!global[globalKey]) {
    global[globalKey] = new classDef()
  }
  return global[globalKey]
}
